import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/icon/Icon';
import SideNavFooter from './SideNavFooter';

export interface SideNavProps {
  onBrand: () => void;
  hasAddons: boolean;
  children?: ReactNode;
}

const SideNav: React.FC<SideNavProps> = ({ onBrand, hasAddons, children }) => {
  const toggleSideBarMenu = () => {
    document.body.classList.toggle('sidebar-mobile-open');
  };

  const SideNavFooterComponent = SideNavFooter as unknown as React.ComponentType;

  return (
    <nav className="app-sidebar bg-color-dark">
      <section className="sidebar-header bg-color-dark">
        <Link to="/" onClick={onBrand} className="brand">
          <Icon icon="Flexi" />
        </Link>
        <div onClick={toggleSideBarMenu} className="app-sidebar--burger">
          <Icon
            className="app-sidebar--burger-icon"
            icon="keyboard_arrow_right"
          />
        </div>
      </section>
      <section className="sidebar-body bg-color-dark">
        {hasAddons && children}
      </section>
      <SideNavFooterComponent />
    </nav>
  );
};

export default SideNav;
